import { z } from 'zod/v4';

import { sectionCommonShapeLegacy } from './data';

/**
 * Ordinary section — a row of columns inside a block.
 *
 * `type` is `z.literal('DEFAULT').optional()` so sections persisted before the
 * discriminator existed (they omit `type` entirely) parse here, and the
 * discriminated union in `./entity.ts` falls through to this branch when the
 * field is missing. Unlike blocks, nothing backfills the tag before the entity
 * reaches the schema.
 */
export const sectionLegacyDefaultV0Schema = z.object({
    ...sectionCommonShapeLegacy,
    type: z.literal('DEFAULT').optional(),
});
